export type WeekDay = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY';

/** One time range on one weekday (Europe/Berlin), from inclusive, to exclusive, 'HH:mm'. */
export interface OpeningHoursSlot {
  dayOfWeek: WeekDay;
  from: string;
  to: string;
}

export interface AdvisorOpeningHours {
  slots: OpeningHoursSlot[];
  replyText: string;
}
